import React, { useEffect } from "react";
import { Provider as ReduxProvide } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor, useAppSelector } from "./store";
import { ToastContainer } from "react-toastify";
import { I18nextProvider } from "react-i18next";
import { useTranslation } from 'react-i18next'

import PageRouter from "setup/PageRouter";
import OverlayLoading from "./components/OverlayLoading";
import { ConfigProvider, message } from "antd";
import SocketProvider from "./websocket";
import i18next from './locales/index';

import enUS from 'antd/es/locale/en_US'
import thTH from 'antd/es/locale/th_TH'
import { colors } from "@mui/material";
 import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queryClient";
import { getBangbowSetting } from "services/bangbowApi";
import { getSpeedDestinationSession, saveSpeedDestinationSession } from "utils/session/speedDestinationSession";
import { saveFactoryAddressSession } from "utils/session/factoryAddressSession";

 
function App() {
  const { i18n } = useTranslation()
  const isThai = i18n.language === 'th'



  // React.useEffect(() => {
  //   getFirebaseToken();

  //   onForegroundMessage()
  //     .then((payload: any) => {
  //       console.log("Received foreground message: ", payload);
  //       const {
  //         notification: { title, body },
  //       } = payload;

  //     })
  //     .catch((err) =>
  //       console.log(
  //         "An error occured while retrieving foreground message. ",
  //         err
  //       )
  //     );
  // }, []);
  return (
    <ReduxProvide store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <SocketProvider>
          <I18nextProvider i18n={i18next}>
            <ConfigProvider
             locale={isThai ? thTH : enUS}
              theme={{
                token: {
                  colorPrimary: "#2777c8",
                  fontFamily: "Prompt, Roboto, sans-serif",
                  borderRadius: 4,
                  boxShadow: "#84a5b5",
                  colorLink: "#2777c8",
                  colorLinkHover: "#84a5b5",
                
                },

              }}
            >
              <Home />
            </ConfigProvider>
            </I18nextProvider>
          </SocketProvider>
          <ReactQueryDevtools initialIsOpen={false} position="left" /> 
        </QueryClientProvider>
      </PersistGate>
    </ReduxProvide>
  );
}

const Home = () => {
  const { loading } = useAppSelector((state) => state.loading);
  const accessToken = useAppSelector((state) => state.auth.accessToken);
  const contact = useAppSelector((state) => state.auth.contact);

  // ✅ Self-heal: ถ้ามี token อยู่ (รีเฟรชหน้า/เปิดแท็บใหม่) ให้เติม session ที่อยู่โรงงาน + destination preset อัตโนมัติ
  useEffect(() => {
    if (!accessToken) return;

    // 1) Factory address session (origin)
    if (contact?.address_fac) {
      saveFactoryAddressSession(contact.address_fac);
    }

    // 2) Destination preset (north/south) จาก master_bangbow
    const cached = getSpeedDestinationSession();
    if (cached?.north?.postcode && cached?.south?.postcode) return;

    getBangbowSetting()
      .then((res) => {
        saveSpeedDestinationSession(res?.data);
      })
      .catch(() => undefined);
  }, [accessToken, contact]);

  return (
    <>
      {/* spin */}
      <OverlayLoading open={loading} />
      <ToastContainer />
      <PageRouter />
    </>
  );
};

export default App;
